import React from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';
import '../assets/css/watercraft.css';

/**
 * Scopes the watercraft design-system theme (dark-mode-first, green primary) to
 * the watercraft routes, overriding the swimbooker blue set globally in App.tsx.
 * Hex values mirror the AntD-theme convention used there; Tailwind consumers use
 * the `watercraft-*` tokens instead.
 */
export default function WatercraftThemeProvider({
  children,
}: {
  children: React.JSX.Element | null;
}): React.JSX.Element {
  return (
    <ConfigProvider
      theme={{
        algorithm: antdTheme.darkAlgorithm,
        token: {
          colorPrimary: '#1A5C2A',
          colorBgBase: '#0C1A0F',
          colorText: '#EEF4EB',
          colorTextPlaceholder: '#4D7052',
          fontFamily: 'gilroy',
        },
        components: {
          Button: {
            borderRadius: 8,
          },
          Input: {
            colorBgContainer: '#1E3024',
            colorBorder: '#2A4030',
            borderRadius: 8,
          },
        },
      }}
    >
      <div className='watercraft-scope'>{children}</div>
    </ConfigProvider>
  );
}
